import { useTranslation } from "react-i18next";
export const youtubeChannelLink = 'https://www.youtube.com/channel/UC_8tWfEtsz5JxEUy-yyYkJA'

export const social = [
  { name: "instagram", href: 'https://www.instagram.com/elementalclinic?igsh=MTJib2draTc3anB6dQ%3D%3D&utm_source=qr', icon: 'insta' },
  { name: "whatsapp", href: "https://wa.me/97143830500", icon: "whatsapp" },
  { name: "youtube", href: "https://www.youtube.com/@ELEMENTAL_CLINIC_AE", icon: "youtube" },
  { name: "facebook", href: 'https://www.facebook.com/profile.php?id=61590759771392', icon: 'fb' },
]
export const socialContacts = [
  { name: "WhatsApp", href: "https://wa.me/97143830500", icon: "whatsapp-icon" },
  { name: "Instagram", href: "https://www.instagram.com/elementalclinic?igsh=MTJib2draTc3anB6dQ%3D%3D&utm_source=qr", icon: "insta" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61590759771392", icon: "fb" },
]

export const phones = [{
  title: '+971 4 383 0500',
  href: 'tel:+97143830500',
  icon: "phone-icon",
}]

export const email = {
  title: 'appointment@elemental.ae',
  href: 'mailto:appointment@elemental.ae',
  icon: "email-icon",
}

export const emailFooter = {
  title: 'info@elemental.ae',
  href: 'mailto:info@elemental.ae',
  icon: "email-icon",
}

export const legalLinks = {
  newsletter: '/mail.pdf',
  publicOffer: '/oferta.pdf',
  personalDataInstruction: '/personal-data-instruction.pdf',
  personalDataProcessingPolicy: '/Patient Rights and Responsibilities.pdf',
}

const PHONE_ERROR_MESSAGE = 'Please enter a valid phone number, e.g. +971 50 123 4567'

export const formErrors = {
  phone: {
    required: PHONE_ERROR_MESSAGE,
    pattern: PHONE_ERROR_MESSAGE,
  },
  email: {
    validate: 'The data entered is incorrect',
  },
  message: {
    required: 'Please add a message',
  },
  review: {
    required: 'Don’t forget to write a review',
  },
  default: {
    required: 'Required field',
  },
}

export const regExp = {
  phone: /^\+?[\d\s()\-]{7,20}$/,
  email:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  date: /^(((0[1-9]|[12]\d|3[01])\-(0[13578]|1[02])\-((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\-(0[13456789]|1[012])\-((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\-02\-((19|[2-9]\d)\d{2}))|(29\-02\-((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,
}

const UAE_COUNTRY_CODE = '971'
const UAE_MOBILE_WITHOUT_TRUNK = /^5\d{8}$/

export function normalizePhone(value = '') {
  const input = String(value).trim()
  if (!input) return ''

  let digits = input.replace(/\D/g, '')
  if (!digits) return input
  
  if (digits.startsWith('00')) {
    digits = digits.slice(2)
    return `+${digits}`
  } else if (digits.startsWith('05')) {
    return `${UAE_COUNTRY_CODE}${digits.slice(1)}`
  } else if (UAE_MOBILE_WITHOUT_TRUNK.test(digits)) {
    return `${UAE_COUNTRY_CODE}${digits}`
  }

  return input
}
